
const deviceBaseUrl = '/device'

export const DeviceEndpointConst = {
    getDeviceInfo: `${deviceBaseUrl}/list`,
    addEditDeviceInfo: `${deviceBaseUrl}`
}

export const getDeviceById = (id: number) => {
    return `${deviceBaseUrl}/${id}`
}

export const deleteDeviceById = (id: number) => {
    return `${deviceBaseUrl}/${id}`
}